<template>
    <div>
        <div class="modal fade" id="whiteLabelModal" tabindex="-1" role="dialog" aria-labelledby="whiteLabelModal"
             aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="fontModalLabel">White Label Config</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">

                        <form>
                            <div class="row mb-3">
                                <label for="nameInput" class="form-label">Name</label>
                                <input id="nameInput" type="text" class="form-control" placeholder="name"
                                       v-model="whiteLabelConfig.name">
                            </div>

                            <div class="row mb-3">
                                <label for="nameInput" class="form-label">Host Domain</label>
                                <input id="nameInput" type="text" class="form-control" placeholder="www.yourdomainhere.com"
                                       v-model="whiteLabelConfig.host_domain">
                                <div class="form-text">This is domain name where your no-code platform is deployed.</div>
                            </div>

                            <div class="row mb-3">
                                <label for="nameInput" class="form-label">From Email</label>
                                <input id="nameInput" type="text" class="form-control" placeholder="email"
                                       v-model="whiteLabelConfig.app_email">
                                <div class="form-text">This is the email we send from for to your users.</div>
                            </div>

                            <div class="mb-3">
                                <label for="formFile" class="form-label">Upload Logo</label>
                                <input class="form-control" type="file" id="formFile" @change="onLogoSelected">
                                <div class="form-text">Generally around 200 x 50.</div>
                            </div>

                        </form>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn modal-btn btn-primary" @click="yesHandler">Save</button>
                        <button type="button" class="btn modal-btn btn-secondary " @click="noHandler">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import RestService from "../services/RestService";

export default {
    name: 'WhiteLabelModal',
    props: {
        yesEvent: Function,
        whiteLabelConfig: Object,
    },
    data() {
        return {
            model: webase.model,
            logoFile: null,
            service: new RestService('wl'),
            currentModal: null,
            modalElement: null,
        }
    },
    mounted() {
        this.modalElement = document.getElementById('whiteLabelModal')
        this.currentModal = new bootstrap.Modal(this.modalElement)
        this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)
        this.currentModal.show()
    },
    beforeUnmount() {
        // remove the event
        // $('#whiteLabelModal').off('hidden.bs.modal')
        this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
    },
    methods: {
        onModalHidden() {
            this.$emit('noEvent')
        },
        noHandler(e) {
            // hide the modal
            this.currentModal.hide()
        },
        yesHandler(e) {

            let formData = new FormData()
            formData.append('whitelabel_config[name]', this.whiteLabelConfig.name)
            formData.append('whitelabel_config[app_email]', this.whiteLabelConfig.app_email)
            formData.append('whitelabel_config[host_domain]', this.whiteLabelConfig.host_domain)

            if(this.logoFile) {
                formData.append('whitelabel_config[logo]', this.logoFile)
            }

            this.service.update(this.whiteLabelConfig.id, formData).then((response) => {

                console.log('White label config saved')
                console.log(response)

                // call the parent's "yesEvent"
                if (this.yesEvent) {
                    this.yesEvent()
                }

                // hide the modal
                this.noHandler()
            }).catch((error) => {
                console.log('Error loading app templates.')
                console.log(error)
            })
        },

        onLogoSelected(event) {
            let files = event.target.files

            if (files && files[0]) {
                this.logoFile = files[0]
            }
        },
    }
}
</script>
